// @core/api/endpoints/affiliate/approve_affiliate.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AffiliateResponse,
  ApproveAffiliateRequest,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Approve affiliate application
 * Performs approve operation on affiliate.
 */
export async function ApproveAffiliate(
  affiliate_id: string,
  data: ApproveAffiliateRequest,
  options?: RequestOptions
): Promise<AffiliateResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/affiliates/:affiliate_id/approve`;
  requestPath = requestPath.replace(':affiliate_id', encodeURIComponent(affiliate_id));
  const requestOptions = options;
  return client.post<AffiliateResponse>(requestPath, data, requestOptions);
}
